// OP-31784 new field medSeriesRank; other sorting params unreliable when getting meds in
// a date range
const sortSeriesRank = (a, b) => Number(b.medseriesrank) - Number(a.medseriesrank); // sort series against each other alphabetically by drugdescription


const sortSeriesList = (a, b) => {
  const seriesAName = String(a[0].drugdescription);
  const seriesBName = String(b[0].drugdescription);
  return seriesAName.localeCompare(seriesBName);
};

export const toSeriesList = meds => {
  const byExteralId = Object.groupBy(meds, medication => medication.externalid); // sort inside each series by med medseriesrank's

  Object.keys(byExteralId).forEach(id => {
    var _byExteralId$id;

    // eslint-disable-next-line no-unused-expressions
    (_byExteralId$id = byExteralId[id]) === null || _byExteralId$id === void 0 ? void 0 : _byExteralId$id.sort(sortSeriesRank);
  });
  const sortedAlph = Object.values(byExteralId).sort(sortSeriesList);
  return sortedAlph;
};